import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------fetch-Query-listing--------------------------
export const fetchQueryListApi = async (data) => {
  const endPoint =
    `/admin/support/query` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};

// ---------------------fetch-Query--------------------------
export const fetchQueryApi = async (id) => {
  const endPoint = `/admin/support/chat?customerSupportQueryId=${id}&limit=1000`;

  return await axios.get(endPoint, setJwtToken());
};

// ---------------------fetch-Query-status--------------------------
export const fetchQueryStatusApi = async (id, payload) => {
  const endPoint = `/admin/support/query_status`;
  return await axios.patch(endPoint, { customerSupportQueryId: id, ...payload }, setJwtToken());
};


// // ---------------------send-Query---------------------------
export const sendChatApi = async (data) => {
  const endPoint = `/admin/support/chat_send`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};

// ---------------------fetch-Support-listing--------------------------
export const fetchSupportListApi = async (data) => {
  const endPoint =
    `/admin/support` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};

// // ---------------------Add-Support---------------------------
export const addSupportApi = async (data) => {
  const endPoint = `/admin/support/add`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};

// // ---------------------update-Support---------------------------
export const updateSupportApi = async (data) => {
  const endPoint = `/admin/support/update`;
  return await axios.put(endPoint, data, setMultiPartHeader());
};

// // ---------------------Delete-Support-API---------------------------
export const deleteSupportApi = async (data) => {
  console.log(data, "Data");
  const endPoint = `/admin/support/delete?supportId=${data}`;
  return await axios.delete(endPoint, setJwtToken());
};
// Send Message Query
export const sendMessageApi = async (data) => {
  console.log("data===>", data)
  const endPoint = `/admin/support/initiate_query`;
  return await axios.post(endPoint, data, setJwtToken());
};



// change status isAdminReply
export const isAdminReplyApi = async (id) => {
  try {
    const endPoint = `/admin/support/update-is-admin-reply`;
    await axios.put(endPoint, { id }, setJwtToken());
  } catch (error) {
    return;
  }
};
export const getChatHistoryApi = async (data) => {
  try {
    const endPoint = `/admin/support/get_chat_history` + "?" + new URLSearchParams({ ...data }).toString();
    return await axios.get(endPoint, setJwtToken());
  } catch (error) {
    return null;
  }
};

// ---------------------fetch-Query-details--------------------------
export const fetchQueryDetailsApi = async (id) => {
  const endPoint = `/admin/support/query_details?customerSupportQueryId=${id}`;
  return await axios.get(endPoint, setJwtToken());
};

export const fetchQueryMastersApi = async (data) => {
  const endPoint =
    `/admin/support/query-masters` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const saveQueryMasterTranslationApi = async (data) => {
  const endPoint = `/admin/support/query-masters/translate`;
  return await axios.post(endPoint, data, setJwtToken());
};